import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=2a51fe84&scoped=true"
import script from "./channel.vue?vue&type=script&lang=js"
export * from "./channel.vue?vue&type=script&lang=js"
import style0 from "./channel.vue?vue&type=style&index=0&id=2a51fe84&prod&lang=scss"
import style1 from "./channel.vue?vue&type=style&index=1&id=2a51fe84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a51fe84",
  null
  
)

export default component.exports